import _URL from '../../URL/index';
const axios = _URL.axios;


export default {
    services: {
        getWaypoints: (reservationId, token) => {
            return axios(token).get(`${_URL._API}/waypoints/reservations/${reservationId}`);
        }
    }
}